import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./fillable-form-field.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./fillable-form-field.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class FillableFormFieldEffects {

  createFillableFormFields$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createFillableFormFields),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FILLABLE_FORM_FIELD,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFillableFormField({ fillableFormField: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateFillableFormField$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editFillableFormFields),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_FILLABLE_FORM_FIELD,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFillableFormField({ fillableFormField: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });



  deleteFillableFormField$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeFillableFormFields),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_FILLABLE_FORM_FIELD,
        variables: {
          fieldUid: action?.fieldUid,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteFillableFormField({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllFillableFormFields$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getFillableFormFields),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_FILLABLE_FFORM_FIELDS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable form fields'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFillableFormFields({ fillableFormFields: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  // CITIZEN

  citizenGetFormFields$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetFormFields),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_FORM_FIELDS,
        fetchPolicy: 'network-only',
        variables: {
          formUniqueId: action.formUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable form fields'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFillableFormFields({ fillableFormFields: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
